@if (showBackToPortalLink) {
  <a (click)="backToDashboard()" class="dashboard-link" [attr.data-transaction-name]="'payment-account-dropdown'">
    <gtr-icon name="chevron-left" size="20"
    [dataTransactionName]="'payment-account-dropdown'"></gtr-icon>
    <span>{{ backLinkLabel }}</span>
  </a>
}

<div class="payment-account-dropdown-wrapper">
  <img src="/assets/images/menu/business-and-trade.svg" alt="company-icon" />
  <div class="dropdown-wrapper flex-grow-1">
    <gtr-select
      [inputLabel]="'Business Account'"
      [lazyLoaded]="true"
      [listLoading]="loading"
      [listLoaderVariation]="loaderVariation"
      [labelKey]="'name'"
      [valueKey]="'id'"
      [subLabel]="'id'"
      [highlightLabel]="'id'"
      [selectedLabel]="'name'"
      [placeholder]="'Select'"
      [options]="paymentAccountsList"
      [textLimit]="30"
      [disabled]="requestLoader"
      [value]="accountId || ''"
      [searchable]="true"
      (valueChanged)="handleValueChange($event)"
      (searchChanged)="onSearchChange($event)"
      (gtrScroll)="handlePagination($event)"
      [dataTransactionName]="'payment-account-dropdown--business-account'"
    ></gtr-select>
  </div>
</div>
